// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import utils from "@/common/utils";
Vue.prototype.$utils = utils;
// import qgdz from 'unit/editor.js'//城市
import store from './store'
Vue.use(ElementUI);

// 过滤器
import filters from "./common/js/filter";
Vue.use(filters);

import qs from "qs"; //转换json用到的插件
import instance from "@/api/resetAxios";
import api from "./api/index";
Vue.prototype.$api = api;
Vue.prototype.$http = instance; //全局注册，使用方法：this.$http
Vue.prototype.$qs = qs;
Vue.prototype.$bus = new Vue();

import VueAwesomeSwiper from "vue-awesome-swiper";
// import style (>= Swiper 6.x)
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

Vue.config.productionTip = false;
// 配置cookie
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
/* eslint-disable no-new */
import { HappyScroll } from "vue-happy-scroll";
//自定义组件名
Vue.component("happy-scroll", HappyScroll);
// 引入css
import "vue-happy-scroll/docs/happy-scroll.css";
let vm = new Vue({
  el: "#app",
  router,
  store,
  history,
  components: {
    App
  },
  template: "<App/>"
});

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);
export default vm



// WEBPACK FOOTER //
// ./src/main.js